import React from "react";
import { ITransport, IDocument } from "dataModels/contract";
import {Row, Col } from "react-grid-system";
import moment from "moment";
import { DATE_FORMAT, DsLayout, FormMode } from "shared/constants";
//import SimpleTable from "components/SimpleTable";
//import { DSAccordion } from "@ds/ds-snam";
//import { createComponent } from "@lit/react";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import SimpleTable, { SimpleTableType } from "components/SimpleTable";
import { useSelector } from "react-redux";
import { RootState } from "state/appStore";
import DSDividers from "@ds/ds-snam/dist/components/dividers";
import DsHorizontalDivider from "components/DsHorizontalDivider";
import { Output } from "@ds/ds-snam/react";
import { IParseDateFormatType, parseDateForDS } from "shared/utils/dateUtils";

interface ITransportFormReviewProps {
    formData: ITransport
}

const TransportInfo: React.FC<ITransportFormReviewProps> = (props): JSX.Element => {
    const { formData } = props;
    const { t } = useTranslation(['contract','app']);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    

    return (
            <Row style={{ marginBottom: "12px" }}>
                <Col>
                
                    <div className="box" style={{/*height:'240px'*/}}>
                        <div className="boxTitle">
                            {/*Informazioni dell'Azienda Trasportatrice*/}
                            {t('transporter.transporterForm.sections.review.title.0')}
                        </div>
                        
                        <div className="boxContent">
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.info.fields.0')}
                                    outputText={formData.businessName}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                {/*<p className="boxFieldLabel">
                                    
                                    {t('transporter.transporterForm.sections.info.fields.0')}
                                </p>
                                <p className="boxFieldData">{formData.businessName}</p>*/}

                            </div>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.info.fields.1')}
                                    outputText={formData.vat}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                {/*<p className="boxFieldLabel">
                                    
                                    {t('transporter.transporterForm.sections.info.fields.1')}
                                </p>
                                <p className="boxFieldData">{formData.vat}</p>*/}

                            </div>
                        </div>
                        <div className="boxContent">
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.info.fields.2')}
                                    outputText={formData.businessSecondName}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                {/*<p className="boxFieldLabel">
                                    
                                    {t('transporter.transporterForm.sections.info.fields.2')}
                                </p>
                                <p className="boxFieldData">{formData.businessSecondName}</p>*/}

                            </div>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.info.fields.3')}
                                    outputText={formData.businessAddress+", "+formData.businessStreetNumber +" - "+ formData.businessCity +" "+formData.businessPostalCode+" ("+ formData.businessProvince+")"}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                {/*<p className="boxFieldLabel">
                                    
                                    {t('transporter.transporterForm.sections.info.fields.3')}
                                </p>
                                <p className="boxFieldData">{formData.businessAddress},{formData.businessStreetNumber} - {formData.businessCity} {formData.businessPostalCode} ({formData.businessProvince})</p>
                                    */}
                            </div>
                        </div>
                        <div className="boxContent">
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.info.fields.8')}
                                    outputText={formData.businessState}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                {/*<p className="boxFieldLabel">
                                    
                                    {t('transporter.transporterForm.sections.info.fields.8')}
                                </p>
                                <p className="boxFieldData">{formData.businessState}</p>*/}
                                
                            </div>
                        </div>
                    </div>
                </Col>
                <Col>
                    <div className="box" style={{height:'240px'}}>
                        <div className="boxTitle">
                           {/*Persona di contatto*/}
                            {t('transporter.transporterForm.sections.contactPerson.title')}
                        </div>
                        <div className="boxContent">
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.contactPerson.fields.0')}
                                    outputText={formData.firstName}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                {/*<p className="boxFieldLabel">
                                    
                                    {t('transporter.transporterForm.sections.contactPerson.fields.0')}
                                </p>
                                <p className="boxFieldData">{formData.firstName}</p>*/}

                            </div>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.contactPerson.fields.1')}
                                    outputText={formData.secondName}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                {/*<p className="boxFieldLabel">
                                    
                                    {t('transporter.transporterForm.sections.contactPerson.fields.1')}
                                </p>
                                <p className="boxFieldData">{formData.secondName}</p>*/}
                            </div>
                        </div>
                        <div className="boxContent">
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.contactPerson.fields.3')}
                                    outputText={formData.countryCode+' '+formData.phone}
                                    style={{marginBottom:'16px'}}
                                ></Output>  
                                {/*<p className="boxFieldLabel">
                                    
                                    {t('transporter.transporterForm.sections.contactPerson.fields.3')}
                                </p>
                                <p className="boxFieldData">{formData.countryCode+' '+formData.phone}</p>*/}

                            </div>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.contactPerson.fields.4')}
                                    outputText={formData.email}
                                    style={{marginBottom:'16px'}}
                                ></Output>  
                                {/*<p className="boxFieldLabel">
                                
                                    {t('transporter.transporterForm.sections.contactPerson.fields.4')}
                                </p>
                                <p className="boxFieldData">{formData.email}</p>*/}
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
    )
}

export default TransportInfo;

